import { SocialNetworkProfile } from '@/hub-shared'
import CreatorProfileInstagram, { CreatorProfileInput } from '@/interfaces/creator-profile.interface'
import Notification from '@interfaces/notification.interface'

export default class HubCoreServiceMock {
  public async getNotifications(page = 1, limit = 100): Promise<Array<Notification>> {
    return [
      {
        id: '655e02ca37c6fa0013d60a81',
        message: 'Mocked notification 1',
        date: new Date().toISOString(),
        type: 'push',
        status: 'read',
        title: 'Notification Title 1',
        link: 'http://example.com/1',
        template: 'template1',
      },
      {
        id: '655e02ca37c6fa0013d60a81',
        message: 'Mocked notification 2',
        date: new Date().toISOString(),
        type: 'push',
        status: 'read',
        title: 'Notification Title 2',
        link: 'http://example.com/2',
        template: 'template2',
      },
    ]
  }

  public async getCreatorProfileBySquidId(squidId: string): Promise<Array<CreatorProfileInstagram>> {
    return [
      {
        profileId: 'profile1',
        socialNetwork: 'instagram',
        username: 'user_insta_1',
        hasCreatorsInsights: true,
        picture: 'http://example.com/user_insta_1.jpg',
        followers: 0,
        hasSocialNetworkCache: false,
        isSharedCreatorsInsights: false,
        hasValidToken: false,
      },
      {
        profileId: 'profile2',
        socialNetwork: 'youtube',
        username: 'user_youtube_1',
        hasCreatorsInsights: false,
        picture: 'http://example.com/user_youtube_1.jpg',
        followers: 0,
        hasSocialNetworkCache: false,
        isSharedCreatorsInsights: false,
        hasValidToken: false,
      },
    ]
  }

  public async activateCreatorProfile(profileId: string, activateCreatorProfileDto: CreatorProfileInput): Promise<void> {
    return Promise.resolve()
  }

  public async generateToken(tokenPayload: string): Promise<{ link: string }> {
    const mockLink = `https://stg-creators-insights.squidit.com.br/token=${encodeURIComponent(tokenPayload)}`
    return { link: mockLink }
  }

  public async deleteSocialNetwork(socialNetwork: string, profileId: string): Promise<void> {
    return Promise.resolve()
  }

  public async getUserSocialNetworkProfiles(socialNetwork: string, page: number, limit: number): Promise<SocialNetworkProfile[]> {
    return [
      {
        id: 'profile1',
        username: 'user_insta_1',
        picture: 'http://example.com/user_insta_1.jpg',
        followers: 0,
        socialNetwork: 'instagram',
        socialNetworkProfilesCache: [],
      },
      {
        id: 'profile2',
        username: 'user_youtube_1',
        picture: 'http://example.com/user_youtube_1.jpg',
        followers: 0,
        socialNetwork: 'youtube',
        socialNetworkProfilesCache: [],
      },
    ]
  }
}
